import React from "react";
import classes from './IconButton.module.css';

function IconButton(props) {
    const iconBtn = `btn btn-sm ${classes.iconBtn}`;

    if (!props.tooltip) {
        return (
            <button type="button" disabled={props.disabled}
                onClick={props.onClick}
                className={`${iconBtn} ${classes.btnWrapper}`}>
                <img src={props.iconImage} alt={props.altText} />
            </button>
        );
    }

    return (
        <div className={`${classes.tooltip} ${classes.btnWrapper}`} disabled={props.disabled}>
            <button type="button"
                onClick={props.onClick}
                className={iconBtn}>
                <img src={props.iconImage} alt={props.altText} />
            </button>
            <span className={classes.tooltiptext}>{props.tooltip}</span>
        </div>
    );
}

export default IconButton;